import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';

import generateID from '../../utils/generate-id';

import colors from 'shared/modules/common/constants/colors';

type Props = {
  id?: string;
};

const Loading = (props: Props) => {
  return (
    <View style={styles.root}>
      <ActivityIndicator
        size="large"
        color={colors.pink}
        /** Generate HTML and Test IDs  */
        {...generateID(props.id)}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
  },
});

export default Loading;
